import { compose, withState, withHandlers } from 'recompose';

export default compose(
  withState('toggled', 'setToggle', false),
  withHandlers({
    toggle: props => () => {
      props.setToggle(!props.toggled);
    },
  }),
);
